{
  "llmModelLabel": "LLM Model",
  "selectLlmModel": "Select a LLM Model",
  "imageUploadLabel": "Image upload (jpg or png)",
  "dragDropText": "Drag & Drop to upload files",
  "browseFiles": "Browse files",
  "executorLabel": "Executor",
  "executorPlaceholder": "This will be sent to an agent for execution",
  "invokeButton": "Invoke",
  "systemMessageLabel": "System Message",
  "userMessageLabel": "User Message",
  "orderSearchTool": "orderSearch",
  "orderSearchDescription": "Returns a list of possible orders in JSON format.\nMust be used to get the full order identifier when incomplete by picking up data from the first item.",
  "orderInfoTool": "orderInfo",
  "orderInfoDescription": "Returns all information about an order as a narrative.\n\nRequires a full order identifier in the format YYYY/MM/DD/00000.",
  "partySearchTool": "partySearch",
  "partySearchDescription": "Returns a list of information about possible persons or companies in JSON format.\n\nIt returns the most approximate names and there is no way to tell if an exact match was found, a list with the matched information must be presented when in doubt.",
  "userInfoTool": "userInfo",
  "userInfoDescription": "Returns all information about the user in JSON format.",
  "prompt": "You are an experienced researcher specializing in Texas real estate law, procedures, and regulations.\n\n## User Information\n{{userInfo}}\n\n## Response Guidelines\n- Reference the user by their first_name field when available\n- Keep responses brief but complete\n- Address the user by first name naturally in conversation\n- Present multi-field data sets as markdown tables instead of prose\n- Deny requests for legal advice, representation, or legal strategy that require licensed attorneys\n- Use all available tools to follow instructions\n- Extract and reference relevant fields from the user information to provide personalized, contextual responses",
  "screenContentPrompt": "\n\nI currently have the following information on screen, consider it and determine if it is relevant:{{screenContent}}",
  "assistant": "Assistant",
  "clearHistory": "Clear history",
  "show-detail-ai": "AI Detail",
  "current-limits": "Current Limits",
  "hourly": "Hourly",
  "weekly": "Weekly",
  "monthly": "Monthly",
  "no-usage": "AI has not been used yet",
  "inference": "Inference",
  "close": "Close",
  "resize-assistant": "Resize assistant",
  "expandAssistant": "Expand to full screen",
  "restoreAssistant": "Restore to side view"
}
